import 'intersection-observer';
import Player from '@vimeo/player';

//Properties
let bgClass = '.js-lazy-bg';
let iframeClass= `.js-lazy-video-slide-iframe`;
let iframeListener = $(iframeClass).find('.lazy-video-slide-iframe');
let options = {rootMargin: "0px 0px 100px 0px"};
let videoContainer = '.js-video-container';

const noImagePath = `/getmedia/68b7baf3-4f28-46f0-bfd2-768177d0bb81/no-image-2.jpg`
//Methods

const initEvents = () => {
	lazyBG();
	lazyIframe();
}

const initPlayer = (iframe) => {
	var player = new Player(iframe);
	player.ready().then(() => {
		player.on('play', () => {
			iframe.addClass('iframe-loaded');
		});

	});
}


const fetchImage = (url) => {
	
	return new Promise((resolve, reject) => {
		const image = new Image();
		image.src = url;
		image.onload = resolve;
		image.onerror = reject;
	});
}

const loadImage = (entry, observer) => {

	const src = entry.dataset.bg;
	const imgContainer = $(entry).find(`.js-lazy-bg__container`);

	fetchImage(src).then(() => {
		
		imgContainer.attr(`style`, `background-image:url("${src}")`)
		imgContainer.addClass(`js-lazy-bg--loaded`)
		observer.unobserve(entry)
		
	}).catch(err => {
		imgContainer.attr(`style`, `background-image:url("${noImagePath}")`)
		imgContainer.addClass(`js-lazy-bg--loaded`)
	})
}

const fetchVimeoJson = async (url) => {
	const response = await fetch(url);
	const jsonFile = await response.json();
	return jsonFile;
  }

const loadIframe = (entry, observer) => {
	const parent = $(entry).parent();
	const iframe = parent.find('iframe');
	const src = iframe.attr('data-src');
	const vimeoLink = `//player.vimeo.com/video/${src}?autoplay=1&loop=1&background=1&muted=1`
	const vimeoJSON = `//vimeo.com/api/v2/video/${src}.json`
	fetchVimeoJson(vimeoJSON).then( json => {

		const rawBG = json[0].thumbnail_large;
		const exactBG = rawBG.replace('_640', `_${window.innerWidth}`);

		fetchImage(exactBG).then(() =>{
			parent.find('.iframe-bg').css(`background-image`,`url(${exactBG})`)
			parent.find('.iframe-bg').addClass('isActive')
		});

	});

	

	if (iframe.attr('src') !== vimeoLink) {
		iframe.attr('src', vimeoLink);
		iframe.on("load", () => {
			initPlayer(iframe);
		})
	}
	observer.unobserve(entry)
}

const handleLazyBG = (entries, observer) => {
	entries.forEach(entry => entry.isIntersecting ? loadImage(entry.target, observer) : null)
}

const handleLazyIframe = (entries, observer) => {
	entries.forEach(entry => entry.isIntersecting ? loadIframe(entry.target, observer) : null)
}

const lazyBG = () => {
	const observer = new IntersectionObserver(handleLazyBG,options)
	$(bgClass).each((i, el) => observer.observe($(bgClass)[i]))
}

const lazyIframe = () => {
	const observer = new IntersectionObserver(handleLazyIframe)
	iframeListener.each((i, el) => observer.observe(iframeListener[i]))
}

//Execution

export const initLazy = {
	init: initEvents,
}